module.exports = __webpack_public_path__ + "static/media/19ESCAP4.de99c719.jpg";